import React, { useEffect, useState } from 'react';

import DOMPurify from 'dompurify';

import Loader from 'components/Loader/index';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import * as notificationManager from 'notifications';
import { FailureNotificationType } from 'notifications';
import { documentsApi } from 'api/DocumentsApi';
import { TRANSCRIPT_AUTHORIZATION_DOCUMENT_TITLE } from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/AgreementPopup/TranscriptAuthorization/transcriptAuthorization.constants';
import styles from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/AgreementPopup/AgreementPopup.module.scss';

const TranscriptAuthorization = () => {
  const { borrower, coBorrower, prequalificationPortal } = useAppSelector((state) => state);
  const [borrowerDocument, setBorrowerDocument] = useState('');
  const [coborrowerDocument, setCoborrowerDocument] = useState('');
  const [loading, setLoading] = useState(true);
  const borrowerFullName = `${borrower.firstName?.toUpperCase()} ${borrower.lastName?.toUpperCase()}`;
  const coborrowerFullName = `${coBorrower?.firstName?.toUpperCase()} ${coBorrower?.lastName?.toUpperCase()}`;

  useEffect(() => {
    const getTranscriptionAuthorizationHtml = async () => {
      try {
        if (!prequalificationPortal.isContractorInfoCheckboxChecked) {
          const transcriptionAuthorizationResponse = await documentsApi.downloadUnacceptedTranscriptAuthorization();

          setBorrowerDocument(transcriptionAuthorizationResponse);
        } else {
          const transcriptionAuthorizationResponse = await documentsApi.downloadAcceptedTranscriptAuthorization({
            firstName: borrower.firstName,
            lastName: borrower.lastName,
            ssn: borrower.personalIdNumber,
            state: borrower.state,
            city: borrower.city,
            streetName: borrower.streetName,
            streetNumber: borrower.streetNumber,
            zip: borrower.zip,
          });

          setBorrowerDocument(transcriptionAuthorizationResponse);

          //Temporary for now, for Andrew to decide whether to display the documents in a row, or in a separate tab
          if (coBorrower.firstName) {
            const transcriptionCobborowerAuthorizationResponse =
              await documentsApi.downloadAcceptedTranscriptAuthorization({
                firstName: coBorrower.firstName,
                lastName: coBorrower.lastName,
                ssn: coBorrower.personalIdNumber,
                state: borrower.state,
                city: borrower.city,
                streetName: borrower.streetName,
                streetNumber: borrower.streetNumber,
                zip: borrower.zip,
              });

            setCoborrowerDocument(transcriptionCobborowerAuthorizationResponse);
          }
        }
      } catch (error) {
        notificationManager.notifyFailure(FailureNotificationType.UnknownError);
      } finally {
        setLoading(false);
      }
    };

    getTranscriptionAuthorizationHtml();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!prequalificationPortal.isContractorInfoCheckboxChecked) {
    return (
      <>
        <p className={styles.title}>{TRANSCRIPT_AUTHORIZATION_DOCUMENT_TITLE}</p>
        <div className={styles.agreementText}>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(borrowerDocument, { FORCE_BODY: true }),
            }}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <p className={styles.title}>{TRANSCRIPT_AUTHORIZATION_DOCUMENT_TITLE}</p>
      <div className={styles.agreementText}>
        {<p className={styles.subTitle}>{borrowerFullName}</p>}
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(borrowerDocument, { FORCE_BODY: true }),
          }}
        />
        {coBorrower?.firstName && (
          <div className={styles.documentContainer}>
            <p className={styles.title}>{TRANSCRIPT_AUTHORIZATION_DOCUMENT_TITLE}</p>
            <p className={styles.subTitle}>{coborrowerFullName}</p>
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(coborrowerDocument, { FORCE_BODY: true }),
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default TranscriptAuthorization;
